export default __webpack_public_path__ + "static/media/pic5.87548cee.jpg";